module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container project_item--testimonial-wrapper"
  }, [_c('img', {
    staticClass: "testimonial_image",
    attrs: {
      "src": _vm.image,
      "alt": 'Photo of ' + _vm.name
    }
  }), _vm._v(" "), _c('blockquote', {
    key: _vm.id,
    staticClass: "project_item--testimonial",
    attrs: {
      "cite": _vm.link
    }
  }, [_vm._v("\n        " + _vm._s(_vm.quote) + "\n        "), _c('cite', [_c('a', {
    staticClass: "testimonial_name",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Opens in linkedIn page in a new tab for ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('span', {
    staticClass: "testimonial_role"
  }, [_vm._v(_vm._s(_vm.role))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6411f713"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project-testimonial/ProjectTestimonial.vue
// module id = 88
// module chunks = 0